import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=28f5a1be&scoped=true&"
import script from "./NoticeModal.vue?vue&type=script&lang=ts&"
export * from "./NoticeModal.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&id=28f5a1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5a1be",
  null
  
)

export default component.exports